import { avoidBreakInside } from '@provider/print';
import { usePageContext } from '../../../../context.js';
import { useTaskContext } from '../../context.js';
import { useMatchTaskBreakpoint, taskBreakpoints } from '../../hook.task-breakpoints.js';
import { ArrowToFacitIcon } from '../icon.arrow-to-facit.js';
import { HyphenatableWordInput } from './input.word.js';
import { wrapper, row, heading, wordContainer, wordScrollContainer, arrowToFacit } from './organism.facit-container.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function FacitContainer(props) {
  const pageContext = usePageContext();
  const context = useTaskContext();
  const isMobile = useMatchTaskBreakpoint(taskBreakpoints.mobile);
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    "data-page-context": pageContext,
    children: [pageContext !== "print" && context === "facit" && !isMobile && /*#__PURE__*/jsxs("div", {
      className: row,
      children: [/*#__PURE__*/jsx("span", {
        className: heading,
        children: "Dit svar"
      }), /*#__PURE__*/jsx("span", {
        className: heading,
        children: "Rigtigt svar"
      })]
    }), props.task.content.map((it, index) => /*#__PURE__*/jsxs("div", {
      className: row,
      "data-hyphenatable": it.meta.hyphenatable,
      ...avoidBreakInside(),
      children: [/*#__PURE__*/jsxs("div", {
        className: wordContainer,
        "data-state": "user-entry",
        children: [context === "facit" && isMobile && it.meta.hyphenatable && /*#__PURE__*/jsx("span", {
          className: heading,
          children: "Dit svar"
        }), /*#__PURE__*/jsx("div", {
          className: wordScrollContainer,
          children: /*#__PURE__*/jsx(HyphenatableWordInput, {
            node: it,
            taskEntryKey: props.taskEntryKey,
            facitContext: "user-entry"
          })
        })]
      }), pageContext !== "print" && context === "facit" && (!isMobile || it.meta.hyphenatable) && /*#__PURE__*/jsxs("div", {
        className: wordContainer,
        "data-state": "should-have",
        children: [isMobile && /*#__PURE__*/jsx("span", {
          className: heading,
          children: "Rigtigt svar"
        }), /*#__PURE__*/jsx(ArrowToFacitIcon, {
          height: isMobile ? 10 : 14,
          className: arrowToFacit
        }), /*#__PURE__*/jsx("div", {
          className: wordScrollContainer,
          children: /*#__PURE__*/jsx(HyphenatableWordInput, {
            node: it,
            taskEntryKey: props.taskEntryKey,
            facitContext: "should-have"
          })
        })]
      })]
    }, index))]
  });
}

export { FacitContainer };
//# sourceMappingURL=organism.facit-container.js.map
